var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 12.6667H14.6667C13.9303 12.6667 13.3334 13.2636 13.3334 14V22C13.3334 22.7364 13.9303 23.3333 14.6667 23.3333H25.3334C26.0698 23.3333 26.6667 22.7364 26.6667 22V14C26.6667 13.2636 26.0698 12.6667 25.3334 12.6667Z",
    stroke: "#EA580C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 14.6667L20.6867 18.4667C20.4809 18.5956 20.2429 18.664 20 18.664C19.7572 18.664 19.5192 18.5956 19.3134 18.4667L13.3334 14.6667",
    stroke: "#EA580C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser3);
export default __webpack_public_path__ + "static/media/User3.97ff7f66166df9c7776e1e25b7fe7a3c.svg";
export { ForwardRef as ReactComponent };